import { useState } from "react";
function isTokenRequiredError(error) {
    if (error.extensions?.code === "AUTH_TOKEN_REQUIRED") {
        return true;
    }
    return false;
}
export function useSecurityTokenMutation(mutationResult) {
    const [tokenRequired, setTokenRequired] = useState(false);
    const originalResponse = mutationResult[1];
    if (originalResponse.error?.graphQLErrors?.find((error) => isTokenRequiredError(error))) {
        if (!tokenRequired) {
            setTokenRequired(true);
        }
    }
    if (originalResponse.error?.graphQLErrors != null) {
        const filteredErrors = originalResponse.error?.graphQLErrors.filter((error) => !isTokenRequiredError(error));
        if (filteredErrors.length === 0) {
            originalResponse.error = undefined;
        }
        else {
            originalResponse.error.graphQLErrors = filteredErrors;
        }
    }
    mutationResult[1].tokenRequired =
        tokenRequired;
    return mutationResult;
}
